import { Alert, Avatar, Button, Flex, Form, Typography } from 'antd'
import { Api } from '~/core/trpc'

type Props = {
  email: string
  onError: (key: string) => void
}

export const StepPasswordForgot: React.FC<Props> = ({ email, onError }) => {
  const resetPassword = Api.authentication.sendResetPasswordEmail.useMutation()

  const handleSubmit = async () => {
    if (resetPassword.isLoading) {
      return
    }

    try {
      await resetPassword.mutateAsync({ email })
    } catch (error) {
      console.error('Unknown Error', error)
      onError('offline')
    }
  }

  const isSuccess = resetPassword.isSuccess

  return (
    <>
      <Flex align="center" gap={8} className="mb-4">
        <Avatar size="small">{email[0].toUpperCase()}</Avatar>
        <Typography.Text strong>{email}</Typography.Text>
      </Flex>

      <Flex vertical gap={16}>
        {isSuccess && (
          <Alert
            style={{ textAlign: 'center' }}
            message={`We sent an email to ${email} with a link to reset your password`}
            type="success"
          />
        )}
        {!isSuccess && (
          <Form onFinish={handleSubmit}>
            <Flex className="mb-6">
              <Typography.Text>You will receive a link</Typography.Text>
            </Flex>

            <Button
              htmlType="submit"
              block
              type="primary"
              loading={resetPassword.isLoading}
            >
              Reset Password
            </Button>
          </Form>
        )}
      </Flex>
    </>
  )
}
